import { useEffect, type RefObject } from 'react';
import debounce from 'lodash/debounce';
import { getWindow } from '../../../utils/getWindow';

const THROTTLE_TIMEOUT = 100;
const RESET_SCROLL_TIMEOUT = 350;

export const useResetScroll = (
    containerRef: RefObject<HTMLDivElement>,
    storageItemName: string,
    isReady?: boolean,
) => {
    const onScroll = debounce((event) => {
        const scrollTop = event.target.scrollTop;

        getWindow()?.sessionStorage.setItem(storageItemName, String(scrollTop));
    }, THROTTLE_TIMEOUT);

    useEffect(() => {
        const containerElement = containerRef.current;

        if (!containerElement || !isReady) {
            return;
        }

        const scrollTop = Number(getWindow()?.sessionStorage.getItem(storageItemName));
        const timerId = setTimeout(() => {
            containerElement.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }, RESET_SCROLL_TIMEOUT);

        return () => clearTimeout(timerId);
    }, [containerRef, isReady, storageItemName]);

    return { onScroll };
};
